import {combineReducers} from "redux";

import {reduceRequestState, reduceResponse, reduceSpreadResponse, RequestState} from "@pg-mono/request-state";

import {fetchPoiRoutesTypes, IOsmPoiRoutes} from "../actions/fetch_osm_poi_routes";
import {fetchPoisRoutesGroupedTypes, IOSMPoisRoutesGrouped} from "../actions/fetch_osm_pois_routes_grouped";
import {fetchPublicTransportRouteTypes} from "../actions/fetch_public_transport_route";
import {IPublicTransportRoute} from "../types/IPublicTransportRoute";
import {IPublicTransportRouteWithStops} from "../types/IPublicTransportRouteWithStops";

export interface IPoiStore {
    poisRoutesGroupedRequest: RequestState;
    poisRoutesGrouped: IOSMPoisRoutesGrouped | null;
    poisRoutes: IOsmPoiRoutes | null;
    poiRoute: Record<string, IPublicTransportRouteWithStops> | null;
}

export const poiReducer = combineReducers({
    poisRoutesGrouped: reduceResponse<IOSMPoisRoutesGrouped>(fetchPoisRoutesGroupedTypes),
    poisRoutesGroupedRequest: reduceRequestState(fetchPoisRoutesGroupedTypes),
    poisRoutes: reduceSpreadResponse<IPublicTransportRoute[]>(fetchPoiRoutesTypes),
    poiRoute: reduceSpreadResponse<IPublicTransportRouteWithStops>(fetchPublicTransportRouteTypes)
});
import {combineReducers} from "redux";

import {reduceRequestState, reduceResponse, reduceSpreadResponse, RequestState} from "@pg-mono/request-state";

import {fetchPoiRoutesTypes, IOsmPoiRoutes} from "../actions/fetch_osm_poi_routes";
import {fetchPoisRoutesGroupedTypes, IOSMPoisRoutesGrouped} from "../actions/fetch_osm_pois_routes_grouped";
import {fetchPublicTransportRouteTypes} from "../actions/fetch_public_transport_route";
import {IPublicTransportRoute} from "../types/IPublicTransportRoute";
import {IPublicTransportRouteWithStops} from "../types/IPublicTransportRouteWithStops";

export interface IPoiStore {
    poisRoutesGroupedRequest: RequestState;
    poisRoutesGrouped: IOSMPoisRoutesGrouped | null;
    poisRoutes: IOsmPoiRoutes | null;
    poiRoute: Record<string, IPublicTransportRouteWithStops> | null;
}

export const poiReducer = combineReducers({
    poisRoutesGrouped: reduceResponse<IOSMPoisRoutesGrouped>(fetchPoisRoutesGroupedTypes),
    poisRoutesGroupedRequest: reduceRequestState(fetchPoisRoutesGroupedTypes),
    poisRoutes: reduceSpreadResponse<IPublicTransportRoute[]>(fetchPoiRoutesTypes),
    poiRoute: reduceSpreadResponse<IPublicTransportRouteWithStops>(fetchPublicTransportRouteTypes)
});
